import { render } from "./IconTurnSlightRight.vue?vue&type=template&id=38b9b12f"
import script from "./IconTurnSlightRight.vue?vue&type=script&lang=js"
export * from "./IconTurnSlightRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__